import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    id: null,
    discountId: null,
    origin: null,
    destination: null
};

class DiscountRule extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(DiscountRule, json, {
            id: fields.string,
            discountId: fields.string,
            origin: fields.string,
            destination: fields.string
        });
    }
}

export default DiscountRule;
